<template>
  <div class="view tagManage-view">
    <HeaderBar />
    <div class="title" v-if="type==0">
      <span>关注频道</span>
      <van-button
        size="mini"
        class="btn"
        @click="onAddClick"
        type="primary"
        :plain="!isAdding"
        >{{ isAdding ? '完成' : '编辑' }}</van-button
      >
    </div>
    <div class="tag-wrap" v-if="type==0">
      <TagItem
        v-for="item in followingList"
        :key="item.id"
        v-bind="item"
        :click="
          () => {
            onFollowingClick(item.id);
          }
        "
      />
    </div>
    <div class="title">
      <span>所有频道</span>
      <van-button
        size="mini"
        class="btn"
        @click="onSortClick"
        type="primary"
        :plain="!isSort"
        >{{ isSort ? '完成' : '排序' }}</van-button
      >
    </div>
    <div class="tag-wrap">
      <TagItem
        v-for="item in tagList"
        :key="item.id"
        v-bind="item"
        :isPrimary="item.id === selTag"
        :disabled="isDisabled(item.id)"
        :click="
          () => {
            onTagClick(item.id);
          }
        "
      />
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'

import { Button } from 'vant';
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
import { getUser, getChannels, setChannels, getFollowingChs, setFollowingChs } from '../../utils/storageUtil';
import HeaderBar from '../../components/HeaderBar';
import TagItem from '../../components/TagItem';
export default {
  name: 'tagManage',
  components: {
    'van-button': Button,
    HeaderBar,
    TagItem
  },
  data() {
    return {
      followingList: [],
      tagList: [],
      isSort: false,
      isAdding: false,
      selTag: 0,
      uid: 0,
      type: 0
    };
  },
  created() {
    const user = getUser();
    this.uid = !!user ? user.uid : 0;
    const {type} = this.$route.query;
    this.type = type;
    this.init();
  },
  methods: {
    async init() {
      const temp = getChannels() || {};
      const tagList = temp[this.type];
      this.followingList = getFollowingChs() || [];
      if(!tagList || this.uid!=0){
        const res = await apiUtil.post(apiConst.getUserTags,{type: this.type});
        if (res.success) {
          const { category, takecare } = res.list;
          let tempList = category.group_b;
          this.tagList = tempList.map(ele => {
            ele.name = ele.cate_name;
            return ele;
          });
          if(Array.isArray(takecare)){
            this.followingList = takecare.map(ele => {
            ele.name = ele.cate_name;
            return ele;
          })
          }
          setChannels(Object.assign({}, getChannels(), {[this.type]: this.tagList}));

          setFollowingChs(this.followingList);
        }
      } else {
        this.tagList = tagList;
      }
      
    },

    onAddClick() {
      if (this.isAdding) {
        this.onSubmitFollowing();
      } else {
        this.isAdding = true;
      }
    },

    onSortClick() {
      if (this.isSort) {
        this.onSubmitSort();
      } else {
        this.isSort = true;
      }
    },

    onTagClick(id) {
      if (this.isAdding) {
        if(!this.isDisabled(id)){
          const item = this.tagList.find(ele => ele.id === id);
          if (item) {
            this.followingList.push(item);
          }
        }
      } else if (this.isSort) {
        if (!this.selTag) {
          this.selTag = id;
        } else {
          if (id === this.selTag) {
            this.selTag = 0;
          } else {
            const index1 = this.tagList.findIndex(
              ele => ele.id === this.selTag
            );
            const index2 = this.tagList.findIndex(ele => ele.id === id);
            let array = this.tagList.slice();
            let temp = array[index1];
            array[index1] = array[index2];
            array[index2] = temp;
            this.tagList = array;
            this.selTag = 0;
          }
        }
      } else {
        if(this.type == 1){
          this.$router.push({ name: 'digital', query: { cate_id: id } });
        } else {
          this.$router.push({ name: 'discover', query: { cate_id: id } });

        }
      }
    },

    onFollowingClick(id) {
      if (this.isAdding) {
        const item = this.followingList.find(ele => ele.id === id);
        if (item) {
          this.followingList = this.followingList.filter(ele => ele.id !== id);
        }
      } else {
        this.$router.push({ name: 'discover', query: { cate_id: id } });
      }
    },

    isDisabled(id){
      return !!(this.followingList.find(ele=>ele.id===id));
    },

    async onSubmitSort() {
      setChannels(Object.assign({}, getChannels(), {[this.type]: this.tagList}));
      if(!!this.uid){
        const res = await apiUtil.post(apiConst.submitTagsSort, {
          uid: this.uid,
          category_id: this.tagList.map(ele => ele.id),
          // type: this.type
        });
        if (res.success) {
          
        }
      }
      this.isSort = false;
      Toast({
        message: '排序已保存',
        duration: 1000,
        background: '#8FC31E'
      });
    },

    async onSubmitFollowing() {
      setFollowingChs(this.followingList);
      if(!!this.uid){
         const res = await apiUtil.post(apiConst.submitTakecare, {
          uid: this.uid,
          category_id: this.followingList.map(ele => ele.id),
          // type: this.type
        });
         // if (res.success) {
     
          // }
      }
        this.isAdding = false;
        Toast({
          message: '关注频道已保存',
          duration: 1000,
          background: '#8FC31E'
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.tagManage-view {
  .header-bar-comp{
    .text--title{
      margin-left: 10px
    }
  }

	.title {
    display: flex
    align-items center
    justify-content space-between
    padding: 0 30px;
    height: 50px;
    color: #333;
    font-size: 32px;
    margin: 30px 0;
    .btn {
      border-radius: 9999px;
      font-size: 32px
      height 48px;
    }
  }

  .tag-wrap {
    padding: 0 21px;
    .tag-item-comp{
      width: 216px;
      height: 80px;
      line-height: 80px;
      font-size: 32px;
      border-radius: 12px;
      margin: 9px;
      background-color: #f5f5f5;
    }
  }
}
</style>
